import _ from 'lodash';
import * as api from 'shared/models/api'
import config from 'sharedConfig';

export function fetch(name) {
  var category = config.nav[name];

  if (category && category.tag) {
    var map = {};
    _.each(config.nav, function(item, k) {
      map[item.tag] = {...item, url: k};
    });

    return api.categories(category.tag, {size: 12}).then(result => {
      var order = category.tag.split(',');
      result = _.map(result, (v, k) => Object.assign(map[k], v));
      result = _.sortBy(result, item => order.indexOf(item.tag));
      return _.assign({}, category, {categories: result, name: name});
    });

  } else {
    return api.getProductsByUrl(name).then(result => {
      const title = (result[0] && result[0].title) || '';
      const categories = [{ title, products: result }];
      return { title, categories };
    });
  }
}



// WEBPACK FOOTER //
// ./shared/models/categoryGroup.js